import React, { useState, useEffect } from "react";
import DashboardLayout from "../DashboardLayout";
import { handleErrors } from "../../services/dataManager";
import { getPaginatedGameBugs } from "../../services/axios/apiManager";
import { useNavigate } from "react-router-dom";
import GameBugsList from "./gameBugsList";
import { useAppContext } from "../../services/context";

const GameBugs = () => {
  const { state } = useAppContext();
  const { permissions } = state;
  const navigate = useNavigate();
  const [gameBugs, setGameBugs] = useState([]);
  const [pagination, setPagination] = useState({});
  const [granted, setGranted] = useState([]);

  const extractPermissions = () => {
    const perms = permissions.filter((f) => f.module === "Bug_Reports");
    if (perms) {
      setGranted(perms);
    }
  };

  const getData = async () => {
    const res = await getPaginatedGameBugs();
    if (res?.data?.success && res?.data?.data) {
      setGameBugs(res.data.data);
      if (res?.data?.pagination) {
        setPagination(res.data.pagination);
      }
    } else {
      handleErrors(res, navigate);
    }
  };
  useEffect(() => {
    extractPermissions();
    getData();
  }, []);
  return (
    <DashboardLayout>
      <div data-testid="bugs">
        <div className="row">
          <div className="col-12 mb-3">
            <div className="page-title-box d-sm-flex align-items-center justify-content-between">
              <div className="page-title-right">
                <ol className="breadcrumb m-0">
                  <li className="breadcrumb-item">
                    <a>Dashboard</a>
                  </li>
                  <li
                    className="breadcrumb-item active"
                    style={{ color: "#d1cdcdbf" }}
                  >
                    Bugs
                  </li>
                </ol>
              </div>
            </div>
          </div>
        </div>
        <GameBugsList
          gameBugs={gameBugs}
          setGameBugs={setGameBugs}
          pagination={pagination}
          setPagination={setPagination}
          granted={granted}
        />
      </div>
    </DashboardLayout>
  );
};

export default GameBugs;
